import React, { ReactNode } from 'react'

import { Text } from '@hhgtech/hhg-components/mantine'
import { Box, BoxProps } from '@mantine/core'

import { Markdown } from 'components/atoms/markdown'
import { useIsMobile } from 'hooks/useIsMobile'

import useStyles from './index.styles'
import { AvatarFocus } from '../avatarFocus'

export type Props = {
  type: 'incoming' | 'incomingWithNoAvatar' | 'current' | 'highlightMessage'
  message: string | ReactNode
} & BoxProps

export const Message = React.memo(
  ({ type, message, styles, classNames, className, ...boxProps }: Props) => {
    const isMobile = useIsMobile()
    const isIncomming = type === 'incoming' || type === 'incomingWithNoAvatar'

    const { classes, cx } = useStyles(
      { isIncomming },
      {
        name: 'AIChatBotWidget__Message',
        styles,
        classNames,
      },
    )

    return message ? (
      <Box className={cx(classes.root, className)} style={styles} {...boxProps}>
        {isIncomming && (
          <AvatarFocus
            className={classes.avatar}
            avatarSize={28}
            borderSize={0}
            sx={{
              ...(type === 'incomingWithNoAvatar' && {
                visibility: 'hidden',
              }),
            }}
          />
        )}
        <div className={classes.contentWrapper}>
          {typeof message === 'string' ? (
            <Text size={isMobile ? 'p3' : 'p4'} className={'content'} as="div">
              <Markdown>{message}</Markdown>
            </Text>
          ) : (
            message
          )}
        </div>
      </Box>
    ) : null
  },
)
